
import React from 'react';

const WhyRefinanceSection: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Lower Monthly Payments',
      description: 'Reduce your monthly mortgage payment by securing a lower interest rate or extending your loan term.'
    },
    {
      icon: 'ri-time-line',
      title: 'Pay Off Faster',
      description: 'Shorten your loan term to build equity faster and save thousands in interest over the life of your loan.'
    },
    {
      icon: 'ri-bank-line',
      title: 'Access Home Equity',
      description: 'Tap into your home\'s equity for renovations, education expenses, or other major investments.'
    },
    {
      icon: 'ri-exchange-line',
      title: 'Switch from ARM to Fixed',
      description: 'Convert from an adjustable-rate mortgage to a fixed-rate loan for predictable payments.'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Consolidate Debt',
      description: 'Roll high-interest credit card debt into your mortgage at a much lower interest rate.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Tailored Payment Solutions',
      description: 'Payment structures can be customized to match individual financial situations and cash flow needs.'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Why Consider Refinancing?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Refinancing your mortgage can help you achieve your financial goals and save money over time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-gray-800 rounded-xl p-8 hover:bg-gray-700 transition-all duration-300 border border-gray-700 hover:border-red-500 group"
            >
              <div className="w-16 h-16 bg-red-600 rounded-lg flex items-center justify-center mb-6 group-hover:bg-red-500 transition-colors duration-300">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                {benefit.title}
              </h3>
              
              <p className="text-gray-300 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyRefinanceSection;